'use client'

import { useTranslations } from 'next-intl'
import { useCallback, useEffect } from 'react'

import { CompanySwitcherSlideIn } from '@maestro/commerce-blocks/components/company-switcher'
import { COMPANY_SWITCHER_MODAL_KEY } from '@maestro/commerce-blocks/components/company-switcher/company-switcher.constants'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

export default function CompanySwitcher() {
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()
  const { removeHashParam } = useHash()

  const closeSwitcher = useCallback(() => {
    removeHashParam(COMPANY_SWITCHER_MODAL_KEY)
  }, [removeHashParam])

  useEffect(() => {
    addModal({
      key: COMPANY_SWITCHER_MODAL_KEY,
      hash: COMPANY_SWITCHER_MODAL_KEY,
      Component: <CompanySwitcherSlideIn onClose={closeSwitcher} />,
      props: {
        title: t('company-switcher.title'),
        customClassName: 'company-switcher',
        hasBackButton: false,
      },
    })
  }, [addModal, closeSwitcher, t])

  return null
}
